module.exports = __webpack_public_path__ + "static/008538-498cdc8af3706b1fadefc092045c9cfc.jpg";